import { render, staticRenderFns } from "./ProductionOrder.vue?vue&type=template&id=3c48984a&"
import script from "./ProductionOrder.vue?vue&type=script&lang=ts&"
export * from "./ProductionOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports